import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable} from 'rxjs';
import { map } from 'rxjs/operators';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private baseURL = environment.apiURL;
  private permissions: string[] = [];

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  constructor(private http: HttpClient,public router: Router) { }

  login(username: string, password: string): Observable<boolean> {
    return this.http.post<{token: string}>(this.baseURL+'/login', {username: username, password: password})
      .pipe(
        map((response:any) => {
          //Set token
          if(response.token){
            localStorage.setItem('accessToken', response.token);
          }

          //Set user info
          let user_data=JSON.stringify(response);

          const obj_user = JSON.parse(user_data, function (_key,value) {
            return value;
          });

          localStorage.setItem('userID', obj_user.user.id);
          localStorage.setItem('userFullName', obj_user.user.name);
          localStorage.setItem('userEmail', obj_user.user.email);
          localStorage.setItem('userPermissions', JSON.stringify(response.permissions));
          localStorage.setItem('dashBoard', response.dashboard);
          localStorage.setItem('language', obj_user.user.lang_code);
          localStorage.setItem('orgId', obj_user.user.org_id);
          localStorage.setItem('locationId', obj_user.user.location_id);
          localStorage.setItem('branchId', obj_user.user.branch_id);
          localStorage.setItem('stockAccessLevel', obj_user.user.stk_access_level);

          return true;
        })
      );
  }

  getToken() {
    return localStorage.getItem('accessToken');
  }

  logout(){
    return this.http.post(this.baseURL+"/logout",this.httpOptions);
  }

  public get isLoggedIn(): boolean {
    let is_logged_in:boolean=false;
    let accessToken=localStorage.getItem('accessToken');

    if(accessToken!==null){
      is_logged_in=true;
    }

    return is_logged_in;
  }

  getPermissions() {
    let permissionsJson = localStorage.getItem('userPermissions');
    this.permissions=permissionsJson ? JSON.parse(permissionsJson) : null;

    return this.permissions;
  }

  getDashboard() {
    return localStorage.getItem('dashBoard');
  }
}
